import { useCallback } from 'react';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import type { ViewSetting } from '@view-model/domain/view';
import { useTranslation } from 'react-i18next';
type Props = {
  isOpen: boolean;
  viewSetting: ViewSetting;
  onClose(): void;
  onShowNodeCreatedUserChanged(checked: boolean, isLocked: boolean, isPositionFixed: boolean): void;
};

export const ViewSettingModal: React.FC<Props> = ({
  isOpen,
  viewSetting,
  onClose,
  onShowNodeCreatedUserChanged,
}: Props) => {
  const { t } = useTranslation();
  const handleChangeShowNodeCreatedUser = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onShowNodeCreatedUserChanged(event.target.checked, viewSetting.isLocked, viewSetting.isPositionFixed);
    },
    [onShowNodeCreatedUserChanged, viewSetting.isLocked, viewSetting.isPositionFixed]
  );

  const handleChangeIsLocked = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onShowNodeCreatedUserChanged(viewSetting.showNodeCreatedUser, event.target.checked, viewSetting.isPositionFixed);
    },
    [onShowNodeCreatedUserChanged, viewSetting.isPositionFixed, viewSetting.showNodeCreatedUser]
  );

  const handleChangeisPositionFixed = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onShowNodeCreatedUserChanged(viewSetting.showNodeCreatedUser, viewSetting.isLocked, event.target.checked);
    },
    [onShowNodeCreatedUserChanged, viewSetting.isLocked, viewSetting.showNodeCreatedUser]
  );

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('canvas.viewSetting.label')}
      submitButton={<></>}
      cancelButton={<></>}
    >
      <div className="p-4">
        <label>
          <input
            type="checkbox"
            className="form-checkbox size-6 border-brand"
            checked={viewSetting.showNodeCreatedUser}
            onChange={handleChangeShowNodeCreatedUser}
          />
          <span className="ml-2">{t('canvas.viewSetting.showCreatedUserIcon')}</span>
        </label>
      </div>
      <div className="p-4">
        <label>
          <input
            type="checkbox"
            className="form-checkbox size-6 border-brand"
            checked={viewSetting.isLocked}
            onChange={handleChangeIsLocked}
          />
          <span className="ml-2">{t('canvas.viewSetting.lockEdit')}</span>
        </label>
      </div>
      <div className="p-4 pb-16">
        <label>
          <input
            type="checkbox"
            className="form-checkbox size-6 border-brand"
            checked={viewSetting.isPositionFixed}
            onChange={handleChangeisPositionFixed}
          />
          <span className="ml-2">{t('canvas.viewSetting.fixPosition')}</span>
        </label>
      </div>
    </GeneralModal>
  );
};
